import "./styles/index.css";

import { initConsent } from "./scripts/consent";
import { initHeroFilm } from "./scripts/hero-film";
import { initNavigation } from "./scripts/navigation";
import { initVideoFacades } from "./scripts/video-facade";
import { initMapEmbed } from "./scripts/map-embed";
import { initForms } from "./scripts/forms";
import { initLightbox } from "./scripts/lightbox";
import { initGalleryMore } from "./scripts/gallery-more";
import { initRails } from "./scripts/rail";
import { initToTop } from "./scripts/to-top";
import { initSearch } from "./scripts/search";
import { initSiteMap } from "./scripts/site-map";
import { initActionBar } from "./scripts/action-bar";
import { initRoomFilter } from "./scripts/room-filter";
import { initPageTransition } from "./scripts/page-transition";

// Consent goes first: the hero film and both facades below read the stored answer as they mount.
initConsent();
initHeroFilm();
initNavigation();
initVideoFacades();
initMapEmbed();
initForms();
initLightbox();
initGalleryMore();
initRails();
initToTop();
initSearch();
initSiteMap();
initActionBar();
initRoomFilter();
initPageTransition();
